module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/placeType.svg?f13340ee";